import Ajax from '../js/common/ajax';
export default {
	list(params) {
		return Ajax.get("/community/list", params)
	},
    buslist(params) {
		return Ajax.get("/businesses/listByCommunity/"+params.communityId, params)
	},
    storeList(params) {
		return Ajax.get("/store/listByCommunity/"+params.communityId, params)
	},
	bindNewUser(params = {}) {
		return Ajax.post("/community/bindAccountUser", params)
	},

	//生活服务人员部分

	//获取生活服务人员下拉列表
	getWaiterList(accountSetsId) {
		return Ajax.get("/waiter/selectList/"+accountSetsId)
	},
	//获取关联店铺
	getStoreList(accountSetsId) {
		return Ajax.get("/store/listByAccountSetsId/"+accountSetsId)
	},
	//获取生活服务人员列表
	waiterQueryList(params) {
		return Ajax.get("/waiter/list",params)
	},
	//获取生活服务人员订单列表
	waiterOrderQueryList(params){
		return Ajax.get("/mallOrder/waiterOrderQueryList",params)
	},
	//获取生活服务人员订单列表头部统计
	getOrderTally(waiterId){
		return Ajax.get("/waiter/getOrderTally/" + waiterId)
	},
	//获取生活服务人员提现列表
	waiterCashOutList(params){
		return Ajax.get("/waiterCashOut/list",params)
	}
}